import { useAtomValue } from "jotai";
import { AllSessionAtom } from "../store";

export function useAllSession() {
    const sessions = useAtomValue(AllSessionAtom);

    function findSession(sessionId: string) {
        return sessions.find(item => item.guid === sessionId);
    }

    function findMessage(sessionId: string, messageId: string) {
        const session = findSession(sessionId);
        if (!session) return;
        return session.chatMessages.find(item => item.guid === messageId);
    }

    return { sessions, findSession, findMessage };
}
